import { useCallback } from 'react';

import { InlineImageUploader } from '@/components/form/util/getRichTextFieldConfig.util.ts';
import { downscaleImage } from '@/utils/downscaleImage.util.ts';

import { useAddAttachment } from '../../attachments/util/useAddAttachment.util.ts';

export const useInlineImageUploader = (
  emailId: string | undefined,
): InlineImageUploader | undefined => {
  const { addAttachment } = useAddAttachment();

  const upload = useCallback<InlineImageUploader>(
    async file => {
      if (!emailId) {
        throw new Error('Brak szkicu, do którego można dołączyć obraz');
      }
      const response = await addAttachment({
        emailId,
        file: await downscaleImage(file),
        inline: true,
      });
      if (!response.inlineUrl) {
        throw new Error('Serwer nie zwrócił adresu obrazu');
      }
      return response.inlineUrl;
    },
    [addAttachment, emailId],
  );

  return emailId ? upload : undefined;
};
